<script setup lang="ts">
const router = useRouter();

definePage({
  meta: {
    navActiveLink: "setting-tab-module-settings",
  },
});

onMounted(() => {
  router.replace({
    name: "setting-tab",
    params: { tab: "module-settings" },
  });
});
</script>

<template>
  <div class="pa-6 text-body-2 text-medium-emphasis">
    Redirecting to settings...
  </div>
</template>
